import { Controller } from "@hotwired/stimulus"

/**
 * Controller que se activa cuando llega una notificación de geocodificación.
 * Dispara un evento global para que otros controllers (bike_hunter_tabs) puedan reaccionar.
 */
export default class extends Controller {
  static values = {
    ticketId: Number,
    status: String,
    latitude: Number,
    longitude: Number,
    error: String,
    strategy: String
  }

  connect() {
    console.log(`📍 GeocodeNotification: Ticket ${this.ticketIdValue} - ${this.statusValue}`)

    // Dispatch custom event for other controllers to listen
    const event = new CustomEvent('geocode-completed', {
      detail: {
        ticketId: this.ticketIdValue,
        status: this.statusValue,
        latitude: this.latitudeValue,
        longitude: this.longitudeValue,
        error: this.errorValue,
        strategy: this.strategyValue
      }
    })
    
    window.dispatchEvent(event)

    // Show toast notification to user
    this.showToast()

    // Remove this element after processing (cleanup)
    setTimeout(() => {
      this.element.remove()
    }, 100)
  }

  showToast() {
    const ticketId = this.ticketIdValue
    
    if (this.statusValue === 'success') {
      this.displayToast(
        `✅ Dirección geocodificada`,
        `Ticket #${ticketId} ahora tiene coordenadas. Recalculando ruta...`,
        'success'
      )
    } else {
      this.displayToast(
        `❌ Error de geocodificación`,
        `Ticket #${ticketId}: ${this.errorValue || 'No se pudo obtener coordenadas'}`,
        'error'
      )
    }
  }

  displayToast(title, message, type) {
    // Check if there's a toast container, if not create one
    let container = document.getElementById('toast-container')
    if (!container) {
      container = document.createElement('div')
      container.id = 'toast-container'
      container.className = 'fixed top-4 right-4 z-50 space-y-2'
      document.body.appendChild(container)
    }

    const bgColor = type === 'success' ? 'bg-green-50 border-green-500' : 'bg-red-50 border-red-500'
    const textColor = type === 'success' ? 'text-green-800' : 'text-red-800'
    const iconColor = type === 'success' ? 'text-green-500' : 'text-red-500'
    const icon = type === 'success' 
      ? '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />'
      : '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />'

    const toast = document.createElement('div')
    toast.className = `${bgColor} ${textColor} border-l-4 p-4 rounded shadow-lg max-w-sm animate-slide-in`
    toast.innerHTML = `
      <div class="flex items-start">
        <svg class="h-5 w-5 ${iconColor} mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          ${icon}
        </svg>
        <div>
          <p class="font-medium text-sm">${title}</p>
          <p class="text-xs mt-1 opacity-80">${message}</p>
        </div>
      </div>
    `

    container.appendChild(toast)

    // Auto-remove after 5 seconds
    setTimeout(() => {
      toast.classList.add('animate-fade-out')
      setTimeout(() => toast.remove(), 300)
    }, 5000)
  }
}
